import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getVendorsList(context, payload) {
    return axios
      .get("/api/fulfillment/vendor/list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getVendorsLists(context, id) {
    return axios
      .get(`/api/fulfillment/vendor_list?client_id=${id}`)
      .then((res) => res.data);
  },
  fetchCurrencyList(context, id) {
    if (id == undefined) {
      return axios
        .get(`/api/fulfillment/client_currency`)
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/fulfillment/client_currency?client_id=${id}`)
        .then((res) => res.data);
    }
  },
  createVendor(context, payload) {
    return axios
      .post("/api/fulfillment/vendor/create", payload)
      .then((res) => res.data);
  },
  getvendorDetails(context, id) {
    return axios
      .get(`/api/fulfillment/vendor/get-by-id/${id}`)

      .then((res) => res.data);
  },

  updateVendor(context, payload) {
    return axios
      .put(`/api/fulfillment/vendor/update/${payload.id}`, payload.data)
      .then((res) => res.data);
  },
  downloadVendorTemplate() {
    return axios
      .get(`/api/file_download?file_path=fulfillments/purchase_order.xlsx`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
